module Meevo.Plugins.EmployeeSupplyUsage {
    "use strict";
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.BlockType> {
        public increments = [];
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            public durationIncrements,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings);
            this.durationIncrements.getIncrements(480, false)
                .then((increments) => {
                    this.increments = increments;
                });
        }
    }
/*
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import ISupplyUsageLineItem = Meevo.Model.ISupplyUsageLineItem;
    import InventoryCountLineItems = Meevo.Model.InventoryCountLineItems;
    import Promise = Q.Promise;


    interface ISupplyUsagePostModel {
        usageList: Array<ISupplyUsagePostItem>,
        returnUsageList: Array<Guid>
    }

    interface ISupplyUsagePostItem {
        employee_User_TId: Guid | string,
        variantId: Guid | string,
        prodType: ProductInventoryTypeEnum,
        quantity: number
    }

    interface ISupplyUsageCombinedItem extends ISupplyUsageLineItem{
        lastTransactionId: Guid | string,
        parsedDateCreated: string,
        undo?: boolean
    }

    interface InventorySearchCountLineItems extends InventoryCountLineItems {
        _selected?: boolean,
        quantity?: number,
        _employee?: Meevo.Model.EmployeeListItem
    }

    /**
     * Main Section of EmployeeSupplyUsage
     */
     /*
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        public searching: boolean = false;
        public productSearchCriteria: string;
        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton> = [];
        private _productSearchList: Array<InventorySearchCountLineItems> = [];
        private _usageList: Array<ISupplyUsageLineItem> = [];
        private _filteredUsageList: Array<ISupplyUsageCombinedItem> = [];
        private _combinedUsageList: Array<ISupplyUsageCombinedItem> = [];
        public model: ISupplyUsagePostModel;
        public productSelectedList: Array<InventorySearchCountLineItems> = [];
        public productType: ProductInventoryTypeEnum = ProductInventoryTypeEnum.Retail;

        /**
         * Setting filter status and object with relative to it checks
         * that are used for filtering inventory items and supply list
         */
         /*
        public employeeSearchCriteria = {
            showEmployeesOnly: true,
            showTerminated: false
        };

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected appSettings: Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected contextSecurityKey: string,
            protected switchContextState: Function,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)

            this.noun = noun;
            this.initCustomButtons();
        }

        /**
         * Initialize list of custom buttons (Cancel and Apply)
         * */
         /*
        private initCustomButtons(): void {
            this.customButtonsSet = [
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: this.cancelSearchResults.bind(this),
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => { return this.searching; } ,
                    securityRules: this.contextSecurityKey,
                    position: 'right'
                },
                {
                    text: 'LABEL_APPLY',
                    clickHandler: this.applySearchResults.bind(this),
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => { return this.searching; } ,
                    securityRules: this.contextSecurityKey,
                    position: 'right'
                }
            ]
        }

        /**
         * Creates an instance of this section for use during an add.
         */
        //createSectionModelInstance(postAdd:(data:any)=>any): void {}

        /**
         * Prepare model to save
         * @returns {ISupplyUsagePostModel} model
         * */
         /*
        public preSave (): ISupplyUsagePostModel {
            let uList:Array<ISupplyUsagePostItem> = [];
            let rUList:Array<any> = [];
            let fList:Array<any> = [];

            this.productSelectedList.forEach((item) => {
                if(item._selected){
                    uList.push({
                        employee_User_TId: item._employee && item._employee.id,
                        variantId: item.variantId,
                        prodType: item.productInventoryType,
                        quantity: item.quantity
                    })
                } else {
                    fList.push(item)
                }
            });

            this.filteredUsageList.forEach((item) => {

                if (item.undo) {
                    rUList.push(item.lastTransactionId);
                }
            });

            this.productSelectedList = fList;

            this.model = {
                usageList: uList,
                returnUsageList: rUList
            };

            return this.model;
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
         /*
        public activate(): void {

        }

        get combinedUsageList(): Array<ISupplyUsageCombinedItem> {
            return this._combinedUsageList;
        }

        get usageList(): Array<ISupplyUsageLineItem> {
            return this._usageList;
        }

        get productSearchList(): Array<InventorySearchCountLineItems> {
            return this._productSearchList;
        }

        get productInventoryTypeEnum(): any {
            return ProductInventoryTypeEnum
        }

        set productSearchList(list: Array<InventorySearchCountLineItems>) {
            this._productSearchList = list;
        }

        set usageList(list: Array<ISupplyUsageLineItem>) {
            // parse usage list and create a combined list with all transactions merged together
            let combinedSupplyUsageList: Array<ISupplyUsageCombinedItem> = [];
            list.map((item: ISupplyUsageLineItem) => {
                let unique: boolean = true;

                if(!item.hasOwnProperty('employee_User_TId')){
                    item.employee_User_TId = null;
                    item.employeeUserDisplayName = this.$translate.instant('LABEL_GENERIC_NOT_AVAILABLE');
                }
                
                combinedSupplyUsageList.map((cItem) => {
                    if (cItem.employee_User_TId === item.employee_User_TId && cItem.variant_TId === item.variant_TId) {
                        cItem.quantity += item.quantity;
                        cItem.lastTransactionId = item.employeeSupplyUsage_LId;
                        unique = false;
                    }
                });

                if (unique) {
                    let parsedDateCreated: string = moment(item.dateCreated).format("MM/DD/YY"),
                        combinedItem: ISupplyUsageCombinedItem = <ISupplyUsageCombinedItem>{};

                    angular.extend(combinedItem, item, {
                        parsedDateCreated,
                        lastTransactionId: item.employeeSupplyUsage_LId
                    });
                    combinedSupplyUsageList.push(combinedItem); 
                }
            });


            this._combinedUsageList = combinedSupplyUsageList;

            this._usageList = list;
            this.changedProductType(); // trigger filter of usage list
        }

        get filteredUsageList(): Array<ISupplyUsageCombinedItem> {
            return this._filteredUsageList;
        }
        
        set filteredUsageList(list: Array<ISupplyUsageCombinedItem>) {
            this._filteredUsageList = list;
        }

        /**
         * Fires on changing product type and sets filter status
         * */
         /*
        public changedProductType(): void {
            this.filterSupplyListByProductType();
        }


        /**
         * Filtering supply list by product type
         * @returns {}
         */
         /*
        private filterSupplyListByProductType(): void {
            let list: Array<ISupplyUsageCombinedItem> = [];

            this.combinedUsageList.forEach((item) => {
                if (this.productType === item.productInventoryTypeEnum || ProductInventoryTypeEnum.RetailOrShopSupply === item.productInventoryTypeEnum) {
                    list.push(item);
                }
            });

            this.filteredUsageList = list;
        }

        /**
         * Changed product type
         * @param {boolean} reset - trigger product search model reset if needed
         * */
         /*
        public changedProductSearch(reset: boolean = false): void {
            if (reset) {
                this.productSearchCriteria = '';
            }

            if (this.productSearchCriteria) {
                let criteria = {
                    PageNumber: 0,
                    ItemsPerPage: 10000,
                    criteria: {
                        productObjectState: Meevo.Model.ObjectStateEnum.Active,
                        variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                        isInventoryTrackable: true,
                        manufacturerId: null,
                        floorLocationId: null,
                        inventoryCountOnly: false,
                        filter: this.productSearchCriteria,
                        productInventoryType: this.productType
                    }
                };


                this.searching = true;
                this.switchContextState(true);

                this.busyService.start();
                this.dataService.getListPaged('InventoryCount/ProductVariant', criteria)
                    .then((data: Array<InventoryCountLineItems>) => {
                        console.log(data, 'data')
                        this.productSearchList = data;
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            }
        }

        /**
         * Cancel search results
         * */
         /*
        public cancelSearchResults(): void {
            this.useSearchResults(false);
        }

        /**
         * Apply search results
         * *//*
        public applySearchResults(): void {
            this.useSearchResults(true);
        }

        /**
         * Apply or Cancel search results
         * @param {boolean} apply
         * *//*
        private useSearchResults(apply): void {
            this.searching = false;
            this.productSearchCriteria = '';

            if (apply) {
                let selected: Array<InventorySearchCountLineItems> = this.productSearchList.filter(item => item._selected);
                let uniqueSelected: Array<InventorySearchCountLineItems> = [];

                selected.forEach((newItem: InventorySearchCountLineItems) => {
                    newItem.quantity = 1;
                    if(!this.productSelectedList.some(existingItem => newItem.variantId === existingItem.variantId)){
                        uniqueSelected.push(newItem);
                    }
                });

                this.productSelectedList = this.productSelectedList.concat(uniqueSelected);


            } else {
                this.productSearchList = [];
            }

            this.switchContextState(false);
        }

        /**
         * Removing selected (not saved) supply usage item
         * */
         /*
        public removeSelectedSupplyUsageItem(variantId: Guid): void {
            this.modalService.confirm("MESSAGE_MODAL_CONFIRM_TEST", Meevo.Components.Modal.ModalTranslationModes.Translate)
                .then(() => {
                    this.productSelectedList = this.productSelectedList.filter(item => item.variantId !== variantId);
                });
        }

        /**
         * Marking supply usage item to undo
         * */
         /*
        public undoSelectedProduct(transactionId: Guid): void {
            this.filteredUsageList.forEach((item) => {
                if (item.lastTransactionId === transactionId) {
                    item.undo = !item.undo;
                }
            });
        }

    }
    */

}